export const TestData = { 
    getAllList: function() {
        return this.allList;
    },
    allList : [
        {
            "invId": 5254,
            "itemNo": "1435",
            "itemSeq": 1,
            "itemName": "Super Glider",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "S",
            "invItemID": 54396,
            "categoryId": 0,
            "catString": "516.178.325",
            "catNames": [
                "4 Juniors",
                "Jack Stone",
                "Airport"
            ],
            "catIds": [
                516,
                178,
                325
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/SN/0/1435-1.png",
            "invQty": 2,
            "invColorID": -1,
            "invYN": "Y",
            "invCondition": 1,
            "pccList": [
                null
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 5252,
            "itemNo": "5419",
            "itemSeq": 1,
            "itemName": "Build a Farm",
            "invNew": "U",
            "invComplete": "I",
            "itemType": "S",
            "invItemID": 74411,
            "categoryId": 0,
            "catString": "167.611",
            "catNames": [
                "Duplo",
                "Basic Set"
            ],
            "catIds": [
                167,
                611
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/SN/0/5419-1.png",
            "invQty": 1,
            "invColorID": 0,
            "invYN": "Y",
            "invCondition": 1,
            "pccList": [
                null
            ],
            "markedAsDeletion": false
        },    
        {
            "invId": 5249,
            "itemNo": "3",
            "itemSeq": 0,
            "itemName": "Homemaker Drawer 4 x 4 x 2",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 261,
            "categoryId": 0,
            "catString": "85",
            "catNames": [
                "Homemaker"
            ],
            "catIds": [
                85
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/7/3.png",
            "invQty": 1,
            "invColorID": 7,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                null
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 5250,
            "itemNo": "2954",
            "itemSeq": 0,
            "itemName": "Electric, Control Lab Serial Interface B",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 10760,
            "categoryId": 0,
            "catString": "463",
            "catNames": [
                "Electric, Programmable"
            ],
            "catIds": [
                463
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/10/2954.png",
            "invQty": 1,
            "invColorID": 10,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                null
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 5251,
            "itemNo": "3001",
            "itemSeq": 0,
            "itemName": "Brick 2 x 4",
            "invNew": "N",
            "invComplete": "S",
            "itemType": "P",
            "invItemID": 264,
            "categoryId": 0,
            "catString": "5",
            "catNames": [
                "Brick"
            ],
            "catIds": [
                5
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/105/3001.png",
            "invQty": 1,
            "invColorID": 105,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "4216917"
            ],
            "markedAsDeletion": false
        },
        {
            "invId": 6263,
            "itemNo": "3001",
            "itemSeq": 0,
            "itemName": "Brick 2 x 4",
            "invNew": "N",
            "invComplete": "X",
            "itemType": "P",
            "invItemID": 264,
            "categoryId": 0,
            "catString": "5",
            "catNames": [
                "Brick"
            ],
            "catIds": [
                5
            ],
            "thumbUrl": "//img.bricklink.com/ItemImage/PN/7/3001.png",
            "invQty": 1,
            "invColorID": 7,
            "invYN": "N",
            "invCondition": 1,
            "pccList": [
                "300123"
            ],
            "markedAsDeletion": false
        }
    ]
}